/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { investmentNeedComparableDtoSchema } from "./investmentNeedComparableDtoSchema.ts";
import { z } from "zod/v4";

export const investmentNeedOverviewDtoSchema = z.object({
  roundType: z.optional(z.string()),
  amountRaising: z.optional(z.string()),
  equityRange: z.optional(z.string()),
  get comparables() {
    return z.array(investmentNeedComparableDtoSchema).optional();
  },
});
